// extracted by mini-css-extract-plugin
var _1 = "#211e1f";
var _2 = "#457cbb";
var _3 = "#015d81";
var _4 = "#0278a6";
var _5 = "#0278a6";
var _6 = "#07baff";
var _7 = "#2bc2fc";
var _8 = "#457cbb";
var _9 = "#211e1f";
var _a = "#015d81";
var _b = "#fffbf0";
var _c = "#706c69";
var _d = "#85817c";
var _e = "#999591";
var _f = "#b5b1ac";
var _10 = "#c7c3bc";
var _11 = "#b2d07f";
var _12 = "#006837";
var _13 = "#009245";
var _14 = "#39b54a";
var _15 = "#5aca68";
var _16 = "#89df93";
var _17 = "#d9d5cc";
var _18 = "#ebe8e2";
var _19 = "#faf6ee";
var _1a = "#915300";
var _1b = "#ba6b01";
var _1c = "#eb8b0a";
var _1d = "#faa83c";
var _1e = "#ffbe66";
var _1f = "#cf9fc5";
var _20 = "#e5562e";
var _21 = "#ac0200";
var _22 = "#db0302";
var _23 = "#ff2725";
var _24 = "#ff4e4e";
var _25 = "#f77";
var _26 = "#fff";
var _27 = "#f9ac31";
export { _1 as "black", _2 as "blue", _3 as "blue1", _4 as "blue2", _5 as "blue3", _6 as "blue4", _7 as "blue5", _8 as "brand", _9 as "brandBlack", _a as "brandText", _b as "brandWhite", _c as "gray1", _d as "gray2", _e as "gray3", _f as "gray4", _10 as "gray5", _11 as "green", _12 as "green1", _13 as "green2", _14 as "green3", _15 as "green4", _16 as "green5", _17 as "lightGray1", _18 as "lightGray3", _19 as "lightGray5", _1a as "orange1", _1b as "orange2", _1c as "orange3", _1d as "orange4", _1e as "orange5", _1f as "purple", _20 as "red", _21 as "red1", _22 as "red2", _23 as "red3", _24 as "red4", _25 as "red5", _26 as "white", _27 as "yellow" }
